var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// db/AdornisTodo.ts
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { Arg, Entity, Field, Subscription } from "@adornis/baseql/decorators.js";
import { DataLoadedField } from "@adornis/baseql/decorators/data-loaded-field.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { registerEnum } from "@adornis/baseql/metadata/register.js";
import { getCollectionHandle } from "@adornis/baseql/server/collections.js";
import { context, publishFilter } from "@adornis/baseql/server/context.js";
import { AdornisUser } from "@adornis/users/db/a-user.js";
import { validate } from "@adornis/validation/decorators.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
import { DateTime } from "luxon";
import { catchError, from, map, of, switchMap } from "rxjs";
var AdornisTodoStatus = /* @__PURE__ */ ((AdornisTodoStatus2) => {
  AdornisTodoStatus2["OPEN"] = "OPEN";
  AdornisTodoStatus2["CHECKED"] = "CHECKED";
  return AdornisTodoStatus2;
})(AdornisTodoStatus || {});
registerEnum({ name: "AdornisTodoStatus", enum: AdornisTodoStatus });
var AdornisTodo = class extends MongoEntity {
  static async beforeCreate(entity) {
    entity.createdAt = DateTime.now();
    entity.createdByID = context.serverContext ? "System" : context.userID;
    return super.beforeCreate(entity);
  }
  static async transformBeforeUpdate(oldEntity, update) {
    await super.transformBeforeUpdate(oldEntity, update);
    switch (update.status) {
      case "CHECKED" /* CHECKED */:
        update.checkedAt = DateTime.now();
        break;
      case "OPEN" /* OPEN */:
        update.checkedAt = null;
        break;
      default:
        break;
    }
  }
  static subscribeTodosForUserPaginated(skip, limit, userID, status) {
    return (gqlFields) => {
      const selector = {
        assigneeID: userID
      };
      if (status !== void 0) {
        selector["status"] = status;
      }
      return this.subscribePaginated(skip, limit, selector, {
        sort: {
          status: -1,
          createdAt: -1
        }
      });
    };
  }
  static subscribeNumberOfTodosForUser(userID, status) {
    return (gqlFields) => {
      const selector = {
        assigneeID: userID
      };
      if (status !== void 0) {
        selector["status"] = status;
      }
      const handle = getCollectionHandle(this._collectionName);
      return from(publishFilter(this._class)).pipe(
        switchMap((publishFilter2) => handle.watchQuery(publishFilter2 ? { $and: [publishFilter2, selector] } : selector)),
        map((docs) => docs.length),
        catchError((e) => {
          return of(0);
        })
      );
    };
  }
};
AdornisTodo._class = "AdornisTodo";
AdornisTodo._collectionName = "adornis-todos";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], AdornisTodo.prototype, "name", 2);
__decorateClass([
  Field((type) => AdornisTodoStatus, {
    // @ts-expect-error TODO this is correct but the typing in the @Field seems to be buggy
    default: (v) => v ?? "OPEN" /* OPEN */
  })
], AdornisTodo.prototype, "status", 2);
__decorateClass([
  Field((type) => String)
], AdornisTodo.prototype, "subTodoIDs", 2);
__decorateClass([
  DataLoadedField((type) => [AdornisTodo], ({ subTodoIDs }) => subTodoIDs ?? [])
], AdornisTodo.prototype, "subTodos", 2);
__decorateClass([
  Field((type) => String)
], AdornisTodo.prototype, "createdByID", 2);
__decorateClass([
  DataLoadedField((type) => AdornisUser, ({ createdByID }) => createdByID)
], AdornisTodo.prototype, "createdBy", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], AdornisTodo.prototype, "assigneeID", 2);
__decorateClass([
  DataLoadedField((type) => AdornisUser, ({ assigneeID }) => assigneeID)
], AdornisTodo.prototype, "assignee", 2);
__decorateClass([
  Field((type) => DateTime)
], AdornisTodo.prototype, "createdAt", 2);
__decorateClass([
  Field((type) => DateTime)
], AdornisTodo.prototype, "checkedAt", 2);
__decorateClass([
  Subscription((type) => [AdornisTodo]),
  __decorateParam(0, Arg("skip", (type) => Int)),
  __decorateParam(1, Arg("limit", (type) => Int)),
  __decorateParam(2, Arg("userID", (type) => String)),
  __decorateParam(3, Arg("status", (type) => AdornisTodoStatus))
], AdornisTodo, "subscribeTodosForUserPaginated", 1);
__decorateClass([
  Subscription((type) => Int),
  __decorateParam(0, Arg("userID", (type) => String)),
  __decorateParam(1, Arg("status", (type) => AdornisTodoStatus))
], AdornisTodo, "subscribeNumberOfTodosForUser", 1);
AdornisTodo = __decorateClass([
  Entity()
], AdornisTodo);
export {
  AdornisTodo,
  AdornisTodoStatus
};
